import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { getDataFromTree } from '@apollo/client/react/ssr';
// Hocks
import withApollo from 'hocs/withApollo';
// Layouts
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Main from 'layouts/Main/Main';
import Footer from 'layouts/Footer/Footer';
// Components
import TagStoresComponent from 'components/TagStores/TagStores';
import TagArticles from 'components/TagArticles/TagArticles';

const formatTagName = (tag: string): string =>
  tag.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const Tag: NextPage = () => {
  const router = useRouter();
  const { name } = router.query;
  const displayName = typeof name === 'string' ? formatTagName(name) : '';

  return (
    <>
      <Head
        title={`${displayName} Athletes & Content | MILLIONS`}
        description={`Discover athletes, streams, and content tagged with ${displayName} on MILLIONS. Browse profiles, watch live streams, and shop merchandise.`}
        robots="noindex, follow"
      />
      <Header />
      <Main>
        <TagStoresComponent tagName={name as string} />
        <TagArticles tagName={name as string} />
      </Main>
      <Footer />
    </>
  );
};

export default withApollo(Tag, { getDataFromTree });
